import { Component, DestroyRef, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute, ParamMap } from '@angular/router'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, ListItem } from '../../shared'
import { buildEquipmentLookup, VpEquipmentRow } from '../parts-fluids/parts-fluids-equipment-context'
import { PartsFluidsByEquipmentComponent } from './parts-fluids-by-equipment.component'
import { PartsFluidsByItemComponent } from './parts-fluids-by-item.component'

@Component({
    templateUrl: './parts-fluids-lookup.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavContent,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavOutlet,
        PartsFluidsByEquipmentComponent,
        PartsFluidsByItemComponent,
    ],
})
export class PartsFluidsLookupComponent extends BaseComponent {
    private activatedRoute = inject(ActivatedRoute)
    private destroyRef = inject(DestroyRef)

    activeTab = 1
    equipmentOptions: ListItem<string>[] = []
    selectedEquipment = ''
    selectedItem = ''

    constructor() {
        super()
        this.activatedRoute.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => this.applyQueryParams(params))
        this.loadEquipment()
    }

    loadEquipment() {
        this.cancelableRequest(
            'equipment',
            true,
            this.services.data.get<VpEquipmentRow[]>('api/VpEquipment').subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.equipmentOptions = buildEquipmentLookup(result ?? []).equipmentOptions
                },
            }),
        )
    }

    tabChanged() {
        this.syncQueryParams()
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    onEquipmentChanged(equipment: string) {
        this.selectedEquipment = equipment
        this.activeTab = 1
        this.syncQueryParams()
    }

    onItemChanged(item: string) {
        this.selectedItem = item
        this.activeTab = 2
        this.syncQueryParams()
    }

    private applyQueryParams(params: ParamMap) {
        const tab = params.get('tab') || ''
        if (tab === 'item') this.activeTab = 2
        else if (tab === 'equipment') this.activeTab = 1

        const equipment = params.get('equipment') || ''
        const item = params.get('item') || ''
        if (equipment) this.selectedEquipment = equipment
        if (item) this.selectedItem = item
    }

    private syncQueryParams() {
        this.services.angular.setQueryParams(
            {
                tab: this.activeTab === 2 ? 'item' : 'equipment',
                equipment: this.selectedEquipment,
                item: this.selectedItem,
            },
            this.activatedRoute,
        )
    }
}
